import { FC } from 'react';
import { type ButtonProps, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { Row } from '../Layout';

export type ActionButtonType = {
  label: string;
  onClick?: () => void;
  link?: string;
  hidden?: boolean;
} & Pick<ButtonProps, 'variant' | 'disabled' | 'color'>;

type Props = {
  actions?: Array<ActionButtonType>;
};

const ActionButtons: FC<Props> = ({ actions }) => {
  const history = useHistory();

  const handleClick = (action: ActionButtonType) => {
    if (action.link) {
      history.push(action.link);
    } else {
      action.onClick?.();
    }
  };

  return (
    <Row centered spacing="sm">
      {actions
        ?.filter((action) => !action.hidden)
        .map((action) => (
          <Button
            size="large"
            key={action.label}
            variant={action.variant ?? 'outlined'}
            disabled={action.disabled}
            color={action.color ?? 'primary'}
            onClick={() => {
              handleClick(action);
            }}
          >
            {action.label}
          </Button>
        ))}
    </Row>
  );
};

export default ActionButtons;
